import { render } from "./Checkbox.vue?vue&type=template&id=486b44c4&scoped=true&ts=true"
import script from "./Checkbox.vue?vue&type=script&lang=ts"
export * from "./Checkbox.vue?vue&type=script&lang=ts"

import "./Checkbox.vue?vue&type=style&index=0&id=486b44c4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486b44c4"]])

export default __exports__